// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Guyana */
const GY = /^(?:(?:51[01]|6\d\d|7(?:[0-5]\d|6[0-79]|[78]0))\d{4})$/;

export default GY;
